import {Condition, type Journey} from "../engine/Condition";
import {merchantFunctionModule} from "../../merchant-state/MerchantFunctionModule";
import {toArray} from "../../../../stem-core/base/Utils";


export interface FunctionOptions {
    // Either the function name, or an array of the name followed by its arguments.
    function: string | any[];
    // Arguments for the function, appended after any passed in the function array.
    // An array is spread, anything else is passed as a single argument.
    args?: any;
    event?: string;
    interval?: number;
    equal?: any;
}

export class FunctionCondition extends Condition<FunctionOptions> {
    havePendingResult = false;

    constructor(journey: Journey, options: FunctionOptions, requestReEval: () => void) {
        super(journey, options, requestReEval);

        if (this.options.event != null) {
            this.attachEventListener(window, this.options.event, this.requestReEval);
        }
        if (this.options.interval != null) {
            this.attachInterval(this.requestReEval, this.options.interval);
        }
    }

    evaluateResult(result: any) {
        if (this.options.hasOwnProperty("equal")) {
            return result === this.options.equal;
        }
        return !!result;
    }

    resolvePromiseResult(result: any) {
        this.havePendingResult = false;
        this.cachedResult = result;
        this.requestReEval();
    }

    evaluate() {
        if (this.cachedResult != null) {
            return this.evaluateResult(this.cachedResult);
        }

        // Don't start a new call if there's a pending promise
        if (this.havePendingResult) {
            return null;
        }
        const [success, result] = merchantFunctionModule.call(this.options.function, ...toArray(this.options.args));

        if (!success) {
            // Something failed in finding/executing the merchant's function.
            return null;
        }

        if (result instanceof Promise) {
            this.cachedResult = null;
            this.havePendingResult = true;
            result.then((result) => this.resolvePromiseResult(result), () => this.resolvePromiseResult(null));
            return null;
        }

        return this.evaluateResult(result);
    }
}
